import React, { FC } from 'react';

import i18n from 'i18n';
import PremiumCollectionHeader from '../Premium/PremiumCollectionHeader';
import { PageLayout } from '../../../types/page-layout';
import { ItemLink } from '../../../types/banner';
import { AppType, PageLayoutItemType } from '../../../constants';
import { ItemsPreview } from '../ItemsPreview';
import App from '../../../models/app';
import { getResourceType, getType } from '../../../utils.v2';
import { AppList } from '../AppList/AppList';
import { ClockList } from '../ClockList/ClockList';
import { SearchButton } from '../Button/SearchButton';

interface DiscoveryAppListProps {
  isClock?: boolean;
  appType?: AppType;
  apps: App[];
}

const DiscoveryAppList: FC<DiscoveryAppListProps> = ({ isClock, apps, appType }) =>
  isClock ? (
    <ClockList apps={apps} />
  ) : (
    <React.Fragment>
      <AppList
        apps={apps}
      />
    </React.Fragment>
  );

interface DiscoveryEntryProps {
  pageLayoutItems: PageLayout[];
  userHasGalleryGrant: boolean;
  isClock?: boolean;
  appType: AppType;
  showSearch?: boolean;
}

export const DiscoveryEntry: FC<DiscoveryEntryProps> = ({
  pageLayoutItems = [],
  userHasGalleryGrant,
  isClock,
  appType,
  showSearch
}) => (
  <div>
    {showSearch && <SearchButton />}
    {pageLayoutItems.map((layoutItem, index) => {
      switch (layoutItem.type) {
        case PageLayoutItemType.BANNER_LIST:

          // return (
          //   <BannerCarousel
          //     banners={layoutItem.banners as Banner[]}
          //     key={`layout-item-${index}`}
          //   />
          // );
          // Diables BANNERS
          return;
        case PageLayoutItemType.APP_LIST:
          if (!layoutItem.apps || !layoutItem.apps.length) {
            return;
          }

          const { type, resourceId } = layoutItem.link as ItemLink;
          const resourceType = getResourceType(getType())

          return (
            <ItemsPreview
              id={resourceId}
              collectionType={type}
              isClock={isClock}
              appType={appType}
              name={layoutItem.title as string}
              apps={layoutItem.apps as App[]}
              path={`/v2/${resourceType}/${type.toLowerCase()}/${resourceId}`}
              key={`layout-item-${index}`}
              shouldDisplayViewAll={true}
              footer={isClock && layoutItem.isPremium
                ? <PremiumCollectionHeader
                  userHasGalleryGrant={userHasGalleryGrant}
                  subscribeButtonTrigger={`collection-${resourceId}`}
                />
                : undefined}
            />
          );
        // Full array of apps displayed as one list for tracker gallery and CU1
        case 'FLAT_APP_LIST':
          return (
            <DiscoveryAppList
              apps={layoutItem.apps as App[]}
              key={`layout-item-${index}`}
              isClock={isClock}
              appType={appType}
            />
          );
        default:
        // do nothing
      }
      return undefined;
    })}
  </div>
);
